import * as React from 'react';
import autobind from 'autobind-decorator';
import { resolve } from 'inversify-react';

import { ConfigurationService } from 'src/core/services/configuration.service';
import { LanguageListDataService } from './language.data';
import { TabLanguageView } from './tab-language.view';


interface TabLanguageControllerProps {
	model?: Model;
	dynamicProperties: TabLanguageModel[];
	mode: ControlMode;
	setBusy(isBusy: boolean);
	isRichTextBox: boolean | boolean[];
	onChanged?: (newValue: any) => void;
}

export class TabLanguageController extends React.Component<TabLanguageControllerProps, {}> {
	@resolve
	protected configurationService: ConfigurationService;

	protected languageDataService: LanguageListDataService;

	constructor(props: TabLanguageControllerProps) {
		super(props);
		this.languageDataService = LanguageListDataService.make();
	}

	@autobind
	protected languageQuery(): Promise<QueryResult<LanguageSummary>> {
		return new Promise<QueryResult<LanguageSummary>>((resolve, reject) => {
			this.props.setBusy(true);
			this.languageDataService.addSorting('languageCode', 'asc', true);
			this.languageDataService.load(query => query)
				.then((res) => {
					this.props.setBusy(false);
					resolve({
						items: res,
						totalCount: this.languageDataService.count
					});
				});
		});
	}

	render() {
		return (
			<TabLanguageView
				dynamicProperties={this.props.dynamicProperties}
				model={this.props.model}
				languageQuery={this.languageQuery}
				mode={this.props.mode}
				defaultLanguage={this.configurationService.current}
				isRichTextBox={this.props.isRichTextBox}
				onChanged={this.props.onChanged}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/core/ui/language/tab-language.controller.tsx